export default {
  FEATURED: 'Featured',
  CUISINE: 'Cuisine',
  REVIEWS_AND_GUIDES: 'Reviews & Guides',
};
